import React, { useState } from "react";
import { XLg } from 'react-bootstrap-icons';
import { FullScreenModal } from "../../../libs/common/modal";
import { MediaCard } from "../../media-card";
import * as Styled from "./FullScreenModal.styled";
import { Layout3ModalProps } from "../../../types";
import { colors } from "../../../libs/themes";
import RatingToast from "../../layouts/RatingToast";
import { useTheme } from "styled-components";

type LayoutModalInternalProps = Omit<Layout3ModalProps, 'visibleCount' | 'onScroll'> & {
    title: string;
};
const LayoutModal: React.FC<LayoutModalInternalProps> = ({
    title,
    show,
    onHide,
    remainingMedia,
    onCardClick,
    isSignedIn,
    activePlans,
    hasFullAccess,
    freeTrialPlanIds,
    mediaRating,
    onWatchClick,
    onRatingSuccess,
    sessionToken,
    refreshMediaRatings
}) => {
    const [visibleCount, setVisibleCount] = React.useState(30);
    const [showToast, setShowToast] = useState(false);
    const theme = useTheme();

    const handleRatingSuccessLocal = () => {
        setShowToast(true);
        onRatingSuccess();
        refreshMediaRatings?.()
    };
    // Reset visibleCount when modal opens
    React.useEffect(() => {
        if (show) setVisibleCount(30);
    }, [show]);

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const target = e.currentTarget;
        const scrollPosition = target.scrollTop + target.clientHeight;
        const threshold = 100;

        if (scrollPosition + threshold >= target.scrollHeight && visibleCount < remainingMedia.length) {
            setVisibleCount((prev) => prev + 10);
        }
    };

    return (
        <FullScreenModal
            zIndex={999999990}
            show={show}
            onHide={onHide}
            header={
                <Styled.ModalHeader>
                    <Styled.TitleContainer>
                        {title}
                        <Styled.VideoCount>
                            ({Math.min(visibleCount, remainingMedia.length)} of {remainingMedia.length} videos)
                        </Styled.VideoCount>
                    </Styled.TitleContainer>
                    <Styled.BackArrow onClick={onHide}>
                        <XLg size={23} style={{ color: `${theme?.modalColor ?? colors.text.black}` }} />
                    </Styled.BackArrow>
                </Styled.ModalHeader>
            }
        >
            <Styled.ScrollableContent onScroll={handleScroll}>
                <Styled.MediaGrid>
                    {remainingMedia.slice(0, visibleCount).map((item) => (
                        <MediaCard
                            key={item.id}
                            isPlalist={true}
                            mediaItem={item}
                            cardClick={() => onCardClick(item)}
                            mediaRating={mediaRating.find((m) => m.mediaId === item.mediaId) || 0}
                            enableRatingControls
                            isSignedIn={isSignedIn}
                            hasEligiblePlan={
                                isSignedIn &&
                                (!!item.planDetails?.length
                                    ? !!activePlans.filter((plan) =>
                                        item.planDetails?.some((pd) => pd?.id === plan.id)
                                    ).length ||
                                    freeTrialPlanIds.includes(item.planDetails[0]?.id) ||
                                    hasFullAccess
                                    : true)
                            }
                            onWatchClick={onWatchClick}
                            onRatingSuccess={handleRatingSuccessLocal}
                            sessionToken={sessionToken}
                        />
                    ))}
                    <RatingToast show={showToast} onClose={() => setShowToast(false)} />
                </Styled.MediaGrid>
            </Styled.ScrollableContent>
        </FullScreenModal>
    );
};

export default LayoutModal;